import t from "react";
function e(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
var r = function r(_r) {
  var a = function (t) {
    var r,
      a,
      c,
      n,
      o,
      s = t.arrowSize + t.edgeOffset,
      i = t.arrowDirection.match(/^up|^down/) ? "left" : "top",
      f = function f(t) {
        return "left" === i ? "translateX(".concat(t, ")") : "translateY(".concat(t, ")");
      };
    switch (t.pointTo + "-" + t.arrowPosition) {
      case "left-left":
      case "top-top":
        return e({}, i, -s);
      case "left-center":
      case "top-center":
        return {
          transform: f("-50%")
        };
      case "left-right":
      case "top-bottom":
        return e(r = {}, i, s), e(r, "transform", f("-100%")), r;
      case "center-left":
      case "center-top":
        return e({}, i, "calc(50% - ".concat(s, "px)"));
      case "center-center":
        return e(a = {}, i, "50%"), e(a, "transform", f("-50%")), a;
      case "center-right":
      case "center-bottom":
        return e(c = {}, i, "calc(50% + ".concat(s, "px)")), e(c, "transform", f("-100%")), c;
      case "right-right":
      case "bottom-bottom":
        return e(n = {}, i, "calc(100% + ".concat(s, "px)")), e(n, "transform", f("-100%")), n;
      case "right-center":
      case "bottom-center":
        return e(o = {}, i, "100%"), e(o, "transform", f("-50%")), o;
      case "right-left":
      case "bottom-top":
        return e({}, i, "calc(100% - ".concat(s, "px)"));
    }
  }(_r);
  switch (_r.arrowDirection) {
    case "left":
      a.left = "calc(100% + ".concat(_r.arrowSize, "px");
      break;
    case "right":
      a.left = -_r.arrowSize, a.transform = (a.transform || "") + " translateX(-100%)";
      break;
    case "up":
      a.top = "calc(".concat(_r.arrowSize - 1, "px + 100%)");
      break;
    case "down":
      a.top = -_r.arrowSize, a.transform = (a.transform || "") + " translateY(-100%)";
  }
  return t.createElement("div", {
    className: "popover-content qa-popover-content",
    style: a,
    children: _r.children
  });
};
export { r as Content };